
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'sa311a24c1471a974': `Document`,
'sf9f2c719a04066ec': `App`,
'sa75b95980cd80e78': `Editor`,
's2a75c946ef4dcab7': `Miscellaneous`,
's33f85f24c0f5f008': `Save`,
's0c883713b83616a8': `Save the active document`,
's8670e5ad3bf0dcf8': `Save As`,
's38980f98cb07ceb8': `Save the active document as a copy`,
'sa37fee6a52d18063': `Delete document`,
'sf64a8229a8136552': `Delete a document`,
's2df075aface0dab8': `Share`,
'sb7fb7568f6883ab8': `Share the active document`,
'seec6798afe90ffc8': `Print`,
's600fd23c9ce971e8': `Print the active document`,
's8f4be9f086eb530f': `Undo`,
's7beb1e77e82363eb': `Undo the last change in the active document`,
's7417792bbe720149': `Redo`,
's640bc7710d0143ce': `Redo the last undone change in the active document`,
's2474e7fb1aec9f05': `Test`,
'sc546f489f9c0cced': `Toggles the test mode for the active document`,
'se6297163cac9d276': `Edit source`,
's281d957112b10f12': `Edit the HTML of the document directly`,
's417b90913e05bc17': `Preview`,
'safc6f203342d09e2': `Toggles the preview for the active document`,
's10f3845975a0351e': `Edit Metadata`,
'sea6e7291e27ec53f': `Toggles the metadata editor`,
's70178e04a3b691b6': `Open Settings`,
's0816468df86e4036': `Opens the settings`,
's1f7698c061c208c9': `Open`,
's16f2f1c2c516d307': `Open a document`,
's382a2aa3984474dd': `Create`,
's64dc1fc7e3db45c9': `Create a new document`,
'sd10fdbe6caf9a998': `Line Break`,
'sbefb6064cba01844': `Insert a line break`,
's410c465a5993f82d': `Line Break Opportunity`,
's8df30fe2a50d3479': `Insert a line break opportunity`,
'sf7c0eba7c822e3d6': `Bold`,
'sb9e9a7dd45966756': `Mark the selection as bold`,
's523eb9043213ff0d': `Italic`,
's92f846b9be2e8e8d': `Mark the selection as italic`,
'sb206d700d26b14ff': `Underline`,
's09c3f1d21de14ae1': `Mark the selection as underlined`,
's99b38e000175cc84': `Strikethrough`,
's0396202b716732ec': `Mark the selection as struck through`,
's3cf89cb47fdde7e9': `Link`,
'sf8e82313fa411494': `Mark the selection as a link`,
'sdf946172dfa0328f': `Superscript`,
'saf3da7c95cb17260': `Mark the selection as a superscript`,
's587ac858dd80f6fa': `Subscript`,
'sc5cb39478b9b7625': `Mark the selection as a subscript`,
's3643189d1abbb7f4': `Code`,
'sf86bd4d2982f3b74': `Mark the selection as code`,
'sd29dc07235eea0f5': `Quotation`,
's0e4862e87c7d53ce': `Mark the selection as a quotation`,
'sfb9b6edb0ed378c9': `Citation Source`,
's4a894f57eba1cf1e': `Keyboard Shortcut`,
's41c724f0698148e9': `Mark the selection as a keyboard shortcut`,
's0ca5c0460199cba1': `Abbreviation`,
's2206c42e5b835e6e': `Mark the selection as an abbreviation`,
'sf67571992e7dc88e': `Full Term`,
's1dfb744260fb3a01': `Bidirectional Isolate`,
'sa39c7ac1d37f3bce': `Mark the selection as a 'bidirectional isolate'`,
's4c402ff5355fd310': `Bidirectional Override`,
's02ab1ea8e5100fc1': `Mark the selection as a 'bidirectional override'`,
'se62385ac082368d2': `Mark the selection as a citation source`,
's36a194e38d653a26': `Data Annotation`,
's5a1a0898baf20675': `Mark the selection with a data annotation`,
's9d668a34af4128ff': `Deletion`,
's1c246045629b0016': `Mark the selection as a deletion`,
's94653c76b2d86a04': `Defined Term`,
's1082e1649793dca9': `Mark the selection as a defined term`,
's92b177e579ef7b97': `Emphasis`,
's782eac2b3e80323d': `Mark the selection as emphasized`,
's50489ffb1bde152e': `Insertion`,
'sd1a78e667a1a139f': `Mark the selection as an insertion`,
's3d6a732c792ccb9e': `Ruby Annotation`,
'sdf62e305e1594805': `Mark the selection with a ruby annotation`,
's474f0eec369d02a4': `Sample Output`,
'sf21c1f60c7515f44': `Mark the selection as sample output`,
's4eace13b3ed74187': `Side Comment`,
's864b0e6270e97246': `Mark the selection as a side comment`,
's7bdf0fd5b014d36c': `Strong Importance`,
's550839f3e4e205bb': `Mark the selection as strongly important`,
's3d3efd1e19bdcfb4': `Date/Time Annotation`,
's47e257ae643b5851': `Mark the selection as a date/time annotation`,
'sec2557a35b702525': `Variable`,
'sf59c9081d106dd9c': `Mark the selection as a variable`,
'sb60bc1250aad44c1': `Span`,
's0a7db790db1fc45c': `Mark the selection as a span`,
's599dcd2472c75c19': `Paragraph`,
's5b8cc9bb61ddce15': `Insert a paragraph`,
's6f84199e62584905': `Preformatted Text`,
'sb3ba3276ae93627c': `Insert a preformatted text block`,
's55905c735052d295': `Thematic Break`,
's936aa0b239679585': `Insert a thematic break (usually displayed as a horizontal line)`,
's2f2044f2431a32d5': `Heading`,
's29f21c34494d614d': `Insert a heading (level 1)`,
'sbc5f2e81604bb667': `Heading 2`,
's29ee7434494a0dfe': `Insert a heading (level 2)`,
'sbc5f2d81604bb4b4': `Heading 3`,
's29eb103449472e3b': `Insert a heading (level 3)`,
'sbc5f2c81604bb301': `Heading 4`,
's2a031834495bcdb4': `Insert a heading (level 4)`,
'sbc5f2b81604bb14e': `Heading 5`,
's29ff743449588131': `Insert a heading (level 5)`,
'sbc5f2a81604baf9b': `Heading 6`,
's29fbfc3449557f72': `Insert a heading (level 6)`,
'sec8b0b6c729816b6': `Heading Group`,
's4d528b416ac8dee2': `Insert a heading group`,
's3d249bb480032121': `List`,
's0978fb5ba3145996': `Insert a list (unordered)`,
's377e24af9628c37e': `Ordered List`,
'sdb711380a28fec75': `Insert a list (ordered)`,
's355b21b89ce5d9c5': `Details`,
'sb6103872073d369e': `Insert details`,
'sc9474bf7a0668d73': `Summary`,
'sec30fbb20f102670': `Insert summary`,
's337a1e9022a8d19f': `Table`,
's88a62d29529948fb': `Insert a table`,
's0cf10c4f40588f8d': `Table Caption`,
's0c11e479416c8421': `Insert a table caption`,
's613c6ff83883c04f': `Table Column`,
'sd52660ee947ca58b': `Insert a table column`,
's8517ae4da104b004': `Table Column Group`,
's28b6246ce616a548': `Insert a table column group`,
's21d61916eb8d137d': `Table Body`,
's156647179b21d351': `Insert a table body`,
'sb616811735bfbafd': `Table cell`,
's9faf26107ed49fb9': `Insert a table cell`,
'sa7af797a46c7d09a': `Table Footer`,
'sc252a4e091763606': `Insert a table footer`,
'sb68e83cda6c85af8': `Table header`,
's8f29e48d6b9a1aa8': `Insert a table header row`,
's153bc3c3aa39587b': `Table Head`,
's5d18ca4c3111be6f': `Insert a table head`,
's52af5d7ac34c2163': `Table Row`,
's1988d71ef8060edf': `Insert a table row`,
's5ed03bb1f3a15949': `Picture`,
's93566b84230af4f5': `Insert a picture`,
's4f26e7cb7c0a8318': `Vector Drawing`,
'sfbbab09dbe553571': `Insert a vector drawing (SVG)`,
's5f43af3669b1e098': `Source`,
'sa7dc6b8ef3f595dc': `Insert a source`,
's9e85800d3700e31c': `Track`,
'sf39736a666dbb038': `Insert a track`,
's08e6bd98452e6bb9': `Audio`,
's96532132a29dd542': `Insert audio`,
's85186a61e0d55bac': `Video`,
's9e28faa598332e2b': `Insert video`,
's82665b2ffabc9c0a': `Website`,
'sc3998b77d72c2932': `Insert a website (as an inline frame)`,
'sa78a67272a4a6f95': `Math Formula`,
'saaad98061a20ac39': `Insert a math formula`,
's4802bb8eb52fbdeb': `Portal`,
'sd4368b12645d3c0f': `Insert a portal`,
's9565553d163fc92a': `Script`,
'sbf00e1ee999ea94e': `Insert a script`,
's7f326a142e856656': `Style`,
's6dfb502188a8c7c2': `Insert a style`,
'se47baf2fd16b9d2b': `Template`,
's7b4ba250601b8667': `Insert a template`,
's919e1724f589c9b1': `Slot`,
's32911e52ee8ac745': `Insert a slot`,
'sbbe639e3a3ed95d1': `NoScript`,
's2d995a37cf5e4995': `Insert a NoScript`,
'sb0d4f0f7993cf085': `Set font size`,
's37fa3b9cd51c2dfd': `Sets the selection's font size`,
's9e3dbb678150edd4': `Set font family`,
's1626a7e10a9f9dcc': `Sets the selection's font family`,
'sb1494c08c8c720d1': `Set text color`,
'se1f5bb0386c88f96': `Sets the color of the selected text`,
'sa65d4ad99f1d8c06': `Set text background`,
's34f724979a124c50': `Sets the background color of the selected text`,
'se219da7b1e955c65': `Clear formatting`,
's256ab831a48c941c': `Removes all text formatting from the selection`,
's621ad19d35ba7742': `Copy selection`,
's365280e16a8ea32d': `Copy the selection`,
's73cb20c838e761e1': `Cut selection`,
's8e715248c3a78446': `Cut the selection`,
's13ef8ca26ca8861b': `Cut element`,
's2ced8e8fafb499f6': `Delete element`,
's3eca5a034978754b': `Delete the selection`,
'sbba0156f795d8c07': `Edit selection`,
'sbd181cd54b8402a4': `Edit the selection`,
's06634274f19b0572': `Pin selection`,
'sa53c5cb03a8fda50': `Pin the selection as a snippet in the palette`,
's0dc07f97c821463c': `Comment selection`,
'sf14c35392ec7bf10': `This feature is unavailable in Firefox. It is available in Chrome or Edge.`,
's840fa49e8989c028': `Position/Shape`,
'sa589e1df65dde0ec': `Set the size, padding, and margins of the selected elements`,
's2e4818861000b13f': `Layout`,
's2e39b99cf23606fa': `Set the layout of the selected elements`,
's5c63af7695445fcf': `Text Style`,
'sc8d2c7f6c33a2b32': `Set text style (alignment, indentation, spacing, etc.) of selected elements`,
'seb4e52ef5ec7a7dc': `Colors/Effects`,
's105a06836c40fcb4': `Set filters, color, and blending of selected elements`,
's7060970b5ed20a58': `Interactivity`,
's7f09197a4814079b': `Set interactivity options for selected elements`,
's762e5704cc84089d': `Set other style options of selected elements`,
's83420ad7b6a14db5': `Toggle Dev Tools`,
's7af555180b30a947': `Open the developer tools`,
's3649bacefe731bf6': `Toggle Toolbox`,
's542fcefa0bbaed86': `Open or close the toolbox (only on narrow screens, otherwise, the toolbox is always visible on the side).`,
's380d17664bb69531': `Insert column before`,
's12946ec1b850962c': `Insert column after`,
's0458872c43beadef': `Insert row before`,
's42ffdab1291fb3de': `Insert row after`,
's77318393dfdb0775': `Remove row`,
'sa8b55cab62e439b5': `Remove column`,
'sc6415b50ff928294': `List item`,
'sc24bda3c061fddf8': `Clickable area`,
's5068560b8d39663d': `Clickable map`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's07808b0ca6da8fef': `Fenced Website`,
's6d8c02aee480af7a': `Menu`,
's730182ad28374cda': `Object`,
's123bea44f38abccf': `Insert object`,
'scace301a88231cce': `Embed`,
's91c5ed7769d00b65': `Insert embed`,
'sc50d09edf9325339': `Dialog`,
'sff99962304ac7d25': `Insert a dialog`,
's9ffe1bbe64712bf1': `Canvas`,
'sa7dbe35b758c138d': `Insert a canvas`,
's3d93f9ea0c5a13fa': `Image`,
's8bc4affa761aa8a2': `Insert an image`,
'sc43767deea72e9f3': `Description List`,
'saf312eaeec77a802': `Insert a description list (glossary, term list)`,
's0312976fe9da5951': `Button`,
'sd60c9bbc51375635': `Insert a button`,
'sdb1595f5c742dfbb': `Input`,
's29b24c06315e9343': `Insert an input`,
's9abadcc828884d7b': `Textarea`,
'sf4e0e02a5277ef23': `Insert an textarea`,
'sfc63e31ac7c956ed': `Select`,
's531056f039febd39': `Insert a select`,
'sfc00292e778b67e2': `Meter`,
's52e0bdc3ee304436': `Insert a meter`,
's8c7f51cb067644c7': `Data List`,
'sfa59c7777e2a0eeb': `Insert a data list`,
's7fcb35d23be1e643': `Field Set`,
's2d986d31f8d67357': `Insert a field set`,
's5590dbf7e425789d': `Label`,
's21f8a2eaf5a70749': `Insert a label`,
's4b58c01e2578f5e4': `Legend`,
's3fd83566dd643d10': `Insert a legend`,
'sef75f458d77491af': `Option Group`,
'sceecdd0bb404bc17': `Insert an option group`,
's4802e47fe2e95134': `Option`,
's3cb47df8290fa94c': `Insert an option`,
'sfd77270c3f54f664': `Output`,
'se64f418b4e733b6c': `Insert an output`,
'sa557ae6bee9148a6': `Progress`,
's52777d434baeed9b': `Insert a progress indicator`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
'scc1db59d292cbc4c': `Section`,
's22a2348c46a912a0': `Insert a section`,
's5432ad3c84273229': `Figure`,
'sf486ca1fdbe08645': `Insert a figure`,
'se16c5e66886fbc59': `Article`,
's3f7e097a9b2e6181': `Insert an article`,
's75d83fc3f0cfab40': `Header`,
'sa5c80e623459ffe4': `Insert a header`,
's49e763aed00877a8': `Main`,
's8247d32213e35f24': `Insert a main`,
'sadd352cc7f6f2307': `Aside`,
's743f778233e42a3f': `Insert an aside`,
'scf932a8577057752': `Footer`,
'sa352d168b262aa06': `Insert a footer`,
's07e6118e838b2e23': `Navigation`,
's0a799f583098cadf': `Insert a navigation`,
's35c3125c7750681e': `Blockquote`,
'sa492a51a707930fa': `Insert a blockquote`,
's5d929ff1619ac0c9': `Search`,
'sbb85a407d730e13d': `Insert a search`,
'sfcdd8e672c75b713': `Address`,
's429dd933ba95549b': `Insert an address`,
's07aa10850d9ddcc7': `Form`,
's84e9c7f8785ca60b': `Insert a form`,
'sa5df1bcdba46c3fb': `Figure Caption`,
's33c1450d2822bb0f': `Insert a figure caption`,
's8688d74dd3716d6e': `Keyboard shortcuts for commands`,
'sc3ac225273c8316b': `General`,
's3ae67088bbefba98': `Packages`,
's8a28bad9290d4761': `Oromo`,
's4634541f5056a546': `Abkhazian`,
's59b20e8af32606ed': `Afar`,
'sd2ef82b8ea877c6d': `Afrikaans`,
's2f4d4bfbc466d91f': `Albanian`,
'sb43db07b24da018a': `Amharic`,
'sb884fa76bfc55429': `Arabic`,
'scc56b218a2689c42': `Armenian`,
'sa2cba871f6cdd99f': `Assamese`,
'scf95dcb12a950a5c': `Aymara`,
's9cf68f87b8e6122f': `Azerbaijani`,
's17bfaaa4e7528bc7': `Bashkir`,
'se39c065efa467782': `Basque`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf0c8e2b013e5ff18': `Bhutani`,
's181ef198cf83ec3a': `Bihari`,
's543c237e8c895ce8': `Bislama`,
's93f083e654a45715': `Breton`,
'sffa395f64ec6ac36': `Bulgarian`,
'sbd72dc858de95ce8': `Burmese`,
's1e9c2c654732cc5f': `Byelorussian`,
's545ee1f373f249cf': `Cambodian`,
's1f2b49c1bca2035d': `Catalan`,
's0e44968489e076a8': `Chinese`,
's20deffeecf2699fb': `Corsican`,
's45518abd911471d0': `Croatian`,
'sc94e314312a8900c': `Czech`,
'sd9c21e5f60d6bdd8': `Danish`,
's95d56e58f816d211': `Dutch`,
's4caed5b7a7e5d89b': `English`,
's0a6cb8d42cdb0c4a': `Esperanto`,
'sa6607436f60ccc1a': `Estonian`,
's536695196d0b6dc3': `Faeroese`,
'sd1f10284eeb17b25': `Fiji`,
'sc98b103772de63f4': `Finnish`,
's75a27f43413e02c5': `French`,
's61c017f6d5c303af': `Frisian`,
's990d0e0fa2ab00b5': `Galician`,
'sdc70d81cf6c28533': `Georgian`,
's63e71d20d1eaca93': `German`,
'scf00d48fd5953a03': `Greek`,
's99229574e5692f19': `Greenlandic`,
's1feab14d837eadb0': `Guarani`,
's3f43ef2eaa1ec486': `Gujarati`,
's9fbe26cfd7845469': `Hausa`,
's6b61f8abf89586be': `Hebrew`,
'sb6b268120592dc53': `Hindi`,
'sda9254d1f1228e1a': `Hungarian`,
'sec2da4aa7a02b925': `Icelandic`,
'seb8982ae8c3cdcc5': `Indonesian`,
's9d54869be6794a9f': `Interlingua`,
's9d54829be67943d3': `Interlingue`,
's62b857f5b6693742': `Inupiak`,
'sf5e76f774beb33c2': `Inuktitut`,
's33c18d5a4cbffa2a': `Irish`,
'sd48cc52117f4d68b': `Italian`,
'sdd35b688281b6dea': `Japanese`,
's21d723a1dbcd89c8': `Javanese`,
's1f8e59d0624842ff': `Kannada`,
's81c3d8809658b951': `Kashmiri`,
's01b16a926920908b': `Kazakh`,
's81cf65c5a46dea08': `Kinyarwanda`,
's5bba2ac2e53bd1fd': `Kirghiz`,
'sab726d2db7e6b93d': `Kirundi`,
's94d61907ee22a8c1': `Korean`,
'sb4e003a459464d85': `Kurdish`,
's69b12144dbb6544d': `Laothian`,
'sb70c17f7899f9b01': `Latin`,
'sd3dcb76f7b28adb8': `Latvian`,
'sff303daee4dd9f7b': `Lingala`,
'sb2dc787b0983ebc6': `Lithuanian`,
's441b20a8a50e36b4': `Macedonian`,
'sf3c4da68b08a2590': `Malagasy`,
'sc7eb080b96e244df': `Malay`,
's0dad143dff0079fc': `Malayalam`,
'scabe6ecee5e01fd2': `Maltese`,
'sae9c790b88be7eb9': `Maori`,
's2e969a451b4955d1': `Marathi`,
's5a356677b61a6b7e': `Moldavian`,
's0f17f32919661cff': `Mongolian`,
's9e8d3665edde89a6': `Nauru`,
'sad190f86451081c0': `Nepali`,
'se0a782a8be8e018b': `Norwegian`,
's7a99528e7b64635a': `Occitan`,
's9c11f2d9335d8bd1': `Oriya`,
's54cbfaf2a8da7818': `Pashto`,
'sa40fd43756fa8913': `Persian`,
's03f49e598ffb11cc': `Polish`,
'scf932840a69dbb7c': `Portuguese`,
's74b9781bacfcc87c': `Punjabi`,
's49ad24935b14e3df': `Quechua`,
's960d3a90ac199368': `Rhaeto-Romanian`,
'sc1aa1f6051b7102a': `Romanian`,
'sa30c12014e955946': `Russian`,
's19abee1277c9bca2': `Samoan`,
's006f872a5b7f5279': `Sangro`,
'sbfff51feacf30196': `Sanskrit`,
's1c65f5004a07dcfa': `Scots Gaelic`,
'sf955eff73fb6b573': `Serbian`,
's7995733bf97c01cc': `Serbo-Croatian`,
'scc5ba32e0de06744': `Sesotho`,
's08e12ade32ef8125': `Setswana`,
'sb6434faf698b02a2': `Shona`,
'sb31cdff08b1c5a50': `Sindhi`,
'se308836a594808b6': `Singhalese`,
'sce8a4e3f7c98482d': `Siswati`,
'se0cda6b80a1bb50f': `Slovak`,
'se96d43a515b8451c': `Slovenian`,
's978522fbc9577a7e': `Somali`,
'sf1868dc19e3917bb': `Spanish`,
'sa477cb1825dceb3b': `Sudanese`,
'sbe90de083557ef3e': `Swahili`,
'sae185e6af80ec81e': `Swedish`,
'sae098810f946ca7c': `Tagalog`,
's7b9994904c4f5b54': `Tajik`,
's7136449045eff28c': `Tamil`,
'sae9d739068eee2c5': `Tatar`,
's47a8f6dfb38b9701': `Telugu`,
's4ffac3fb33a2ee9b': `Thai`,
's5623aa2f83b05c76': `Tibetan`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
's04c939a414fdab21': `Tsonga`,
's9d2d00982edafabb': `Turkish`,
'sc0ceaa9843510f67': `Turkmen`,
's6d1df519e235a6cf': `Twi`,
's2e66bf8b833858f3': `Uigur`,
'sc4ee3e4ee994dafd': `Ukrainian`,
's9ca757effd747da9': `Urdu`,
'sb4f0310e6787d098': `Uzbek`,
's6d60d595cb5070da': `Vietnamese`,
'sb657bfe93338dc8b': `Volapuk`,
'sf2e08a945e9194d4': `Welch`,
's86ca34c5287a2f38': `Wolof`,
'sa4e5b39489ecf31a': `Xhosa`,
's63dfc5b1c1c27849': `Yiddish`,
'se1312d6528f9a259': `Yoruba`,
's3f299e83cbf52fba': `Zhuang`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sdef34fe08bb28b09': `Chinese (Simplified)`,
's2739460e44320108': `Chinese (Traditional)`,
's5941292bb77281ab': `Norwegian Bokmål`,
's082869038c117fe5': `Portuguese (Brazil)`,
'se25e4f2cb77b8be8': `Language for the WebWriter interface and new documents`,
'sefcf950b3cc4fc3b': `Language`,
's4ce8cc041a628847': `When the document language is changed, update all widgets' languages accordingly.`,
's3bc203a3f8a6409c': `Update language across document`,
's690da6b432987c6f': `Backup changes to the current document automatically. Changes are restored when WebWriter is reloaded.`,
's888c71e8fcb916d3': `Autosave`,
'se9ac05f36b004eb0': `Hide the introductory tour. Disable so the tour is shown again.`,
'sf2ab37af0abc55ef': `Hide intro tour`,
's3437e0d9899e7ae1': `Send telemetry data about your usage of WebWriter.`,
's80570196a9ce6d11': `Enable telemetry`,
'sb66e2181a7b5738a': `By enabling telemetry, you allow for data collection and retention according to our`,
'sbc6953a36ced943f': `privacy policy`,
'sb19611adbc88f711': `Advanced: Show source editing commands, e.g. to show the document's HTML or to add custom styles and scripts.`,
'sd452cebf4a0313d1': `Show source editing commands`,
'se3b4c857f91f80d7': `Keyboard shortcuts`,
's1696c76a23c0834e': `Advanced: Show packages with versions like 0.x.x in the package manager`,
's71a0549fd71219c9': `Show unstable packages`,
'sc2e2a0dbf03723b7': `Advanced: Show packages from unknown sources in the package manager (Warning: May be unsafe)`,
'sbff54e740c4086eb': `Show unknown packages`,
's9df571714a1efb44': `An autosaved version of this explorable is available. Load it?`,
's75109f5307578a61': `Welcome to WebWriter`,
's1d10d2058d8ca8dd': `Want a short, guided tour?`,
's3bdad99768e11911': `Explorable`,
's0db05bd7ba6fff96': `Your explorable document. You can write text and copy/paste, edit, etc. here.`,
'sc8af536e2084ade0': `Palette`,
's0b24d08ea349b455': `Everything you can insert. At the start are non-interactive elements like lists or images, next are interactive elements called widgets. You can get new ones by clicking the search bar.`,
's24949d7adbb5a098': `Toolbox`,
's806f84eb0ace116e': `See what you have selected and change it. Copy, cut, paste, pin, or make layout changes. Offers different options depending on your selection, i.e. formatting for text.`,
'seaaaeb09e3b4e78b': `Editing commands`,
's8d83386457e91813': `Undo/redo your changes or preview from the learner's perspective.`,
's0e6ea8870dbddab2': `Document commands`,
's0448f1059fa01720': `Save, share or print your explorable. Edit information such as the title, language or license.`,
's0c4b2e98d4ab7f5a': `App commands`,
'sa172190ea21f9b1c': `Access the settings, open an explorable or create a new one.`,
's4cc8391f172c0cdf': `Dismiss tour`,
's575e795c45e2d97e': `Go back`,
'sa778acc33947c7b8': `Finish tour`,
's81ecf2d4386b8e84': `Continue`,
's8f533296a536965e': `Save as...`,
's3a5ca02f282d247e': `Share...`,
'sda2d76b976502a8d': `Open...`,
'sb26035b596566abf': `Unnamed`,
's812cbda653daaeba': `This feature is not implemented yet`,
's35aeaff1425bca9e': `WebWriter does not support media of type `,
's99f110d27e30b289': `Title`,
'sef73fe18e351eb35': `Keywords`,
's63d894b1ddb06289': `Description`,
's01d32b35baa3b676': `Author`,
's17597a8bb4810524': `License`,
'sdc48456f9a27ae02': `Generator`,
's8d342ecaa9e75b9b': `Relationship`,
'sef49aec68fd1dc66': `Name`,
's4ea0f21fc2a338a1': `Move up`,
'sb233557012dcb328': `Move down`,
's3d09398e555ee5f9': `Advanced Options`,
's17fb3f4805f4f4b9': `Remove field`,
'sa6f8d27bca557059': `Move meta/link/style elements up/down into this element`,
's6dadeaaee49d6d18': `Meta`,
's252a52330d32b900': `Metadata`,
's6827930ef1aeaf99': `Base URL`,
's1ca22ce85e074da5': `Pragma`,
's064339c229374050': `Encoding`,
'saab875d8cfcfe712': `Theme`,
'sa417644bef21a9aa': `Unnamed Theme`,
'saa33768e03c45fc8': `File Size`,
's3f06e9abb6ebcb79': `Characters`,
's0f350bc4e538e3ea': `Words`,
's106b274b5af798e5': `Sentences`,
's97aa76056a81bd36': `Metrics`,
's94d2eee44b292567': `Toggle advanced options`,
's98977a87d1b93941': `Reset information, styles and scripts`,
's543906d1db8b2283': `Edit `,
'sddc49047f66a64ab': `No description provided`,
's1641ab440bf4daa4': `Update this widget package`,
'sbd40f40cbadd38d5': `Remove this widget package`,
's54897f2764b0e4d0': `Install this widget package`,
'sd5cf95145e4d89ca': `Unpin this snippet`,
's69a49786a8009f43': `Find packages...`,
's5e2cba97c0d971bd': `Reload packages`,
's30cce87854901922': `Preschool`,
's9485af2e7cd9418f': `Primary school`,
'seaecc8267bad6234': `Middle school`,
's69311c4e25074fb3': `High school`,
'sab5e7d2a069a2951': `Vocational cert.`,
's1d5c7b28e8b50d6d': `Associate deg.`,
's7edbe0b213199995': `Bachelor's`,
'sfe6e758ad2603c1d': `Master's`,
'sb60dd9d23d31ee66': `Doctorate`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's67c2b60a506a09e4': `Secondary ed.`,
'sd5bf67958b08b4cf': `Higher ed.`,
's1d19244f549ec535': `Education`,
'sbe3c60c65f129daa': `Humanities`,
's5e53415a6d5719ad': `Social sciences`,
's233ae776268cd44b': `Business`,
's736904f276fbd441': `Natural sciences`,
's41322d19c928c603': `ICT`,
's5c2a1a52c0389c30': `Engineering`,
's5e9e8e4d21bafedc': `Food production`,
'sbaf0a7c417e388af': `Health`,
'sf55d634dcc743595': `Services`,
's6fb3053e7244d326': `Other fields`,
'sa50d3c35533f1d99': `All fields`,
's5c1ecf88259b79f9': `Presentation`,
's5d87c1e588f48d90': `Practice`,
's7ede1c55e35ce9d6': `Simulation`,
's886c5db2a5579873': `Concept`,
's1eaccbf2d6af8ab5': `Information`,
's63e03c70f67ebf9c': `Context`,
's83c15613b6f6f3c8': `Online only`,
's18d5c44aae3dc82a': `Online when editing`,
'sd05a155fe09c2866': `Online when using`,
's0de0febab8a4beaf': `Error reading this package`,
'scdf536b65be39ec5': ` Create/import`,
'sf2514d5dc78b1654': `Insert widget`,
'sbc5bb5bb74d141b9': `Uninstall`,
's6196153c4b0c1ea0': `Install`,
's8b0432eecbd8b034': `Update`,
's1857db526dc4dcdd': `Create package`,
'sd2addf69477cd4b4': `Import package`,
's7aaf0c06e69600f1': `Error with `,
's00065e45db8c0441': `See developer tools for more details`,
's02106cc2ef0e7578': `New pin...`,
'sb85774dc5d18ff0f': `Confirm`,
's2ceb11be2290bb1b': `Cancel`,
'keyCommand': `⌘ Command/Win`,
'keyShift': `⇧ Shift`,
'keyControl': `^ Control`,
'keyOption': `⌥ Option/Alt`,
's2692bc028fed91f1': `⇪ Caps Lock`,
'backspaceKey': `⟵`,
'tabKey': `⭾ Tab`,
'clearKey': `⎚ Clear`,
'enterKey': `↩ Enter`,
'escapeKey': `⎋ Escape`,
'spaceKey': `Space`,
'upKey': `↑ Up`,
'downKey': `↓ Down`,
'leftKey': `← Left`,
'rightKey': `→ Right`,
'homeKey': `⤒ Home`,
'endKey': `⤓ End`,
'pageupKey': `▲ Pageup`,
'pagedownKey': `▼ Pagedown`,
'deleteKey': `⌦ Delete`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
's7dea785045c3cc74': `Press new key combination...`,
's46d4abe6255cb9e1': `Reassign shortcut`,
'sd1f44f1a8bc20e67': `Email`,
'sf6e1665c7022a1f8': `Password`,
's151bc2eea7a032a4': `-unchanged-`,
's7cb4e55c59663b1c': `Company`,
's5da52af9b083c29a': `Model`,
's9781a5bb3fcb26a3': `Select a company first`,
's15d0c0657c1ee08c': `API Key`,
's268ecd1cef45a9a8': `Are you sure?`,
'sd3f402df8619ddcd': `This information about you is automatically added to new documents. You can change this for each document in the metadata editor.`,
's90105521fcc40453': `WebWriter Cloud accounts allow you store documents online and share them with your students. Add an account here and it will be available as a location for saving, loading, sharing and opening documents.`,
's2712dc5641a33226': `Package registry accounts are intended for developers and allow you to configure one or more registries`,
's429bd646f1cf8bc6': `Grammar LLM accounts allow you to use the Grammar LLM API to correct grammar in text.`,
's669b18c6d2d9c95b': `None`,
's7cfe12cd14df9950': `Sign out`,
's5e27738a2e8eb763': `Sign in`,
'sf28903d4ca0ddcfc': `Remove this account`,
'sb85b1e36579852a6': `Invalid email or password`,
's6988ab5d47593a26': `You have the latest version of WebWriter.`,
'saf440a0a592f2835': `Update to`,
's564d1648b1ceee9f': `Up to date`,
'sf6673729c03ae999': `Reset WebWriter`,
'sf1e79171c4856543': `Are you sure? This action can't be reversed, all your settings will be deleted and reset.`,
's0bdca49248ba4820': `Shortcuts`,
'se48bd9e6c2a3109d': `Accounts`,
's78789724e789221c': `Size`,
's1b4a36fce2456660': `Font Family`,
's11326fd2590f4e5e': `Default`,
's9c356016f81585f6': `Background Color`,
's1f74bdf32b51a5fc': `Background Image`,
's927d796559f49439': `Background Origin`,
's1637c7d1a30629e2': `Border Box`,
'scd15088c39fe9edf': `Padding Box`,
's1db591f5a54dbfd3': `Content Box`,
'sa01e7bf33563ef72': `Background Attachment`,
'sd319aae1401f1e19': `Fixed`,
'se9b1fec72ffd8f48': `Local`,
'sa7698b3d20a6d1ec': `Scroll`,
's89bca7498f20e041': `Background Clip`,
's2492f5fb1b05b45e': `Text`,
's1351209ef74ee729': `Span all columns`,
'sf0cab2483f66aa2e': `Custom`,
's951aa3a6439f1271': `List marker`,
'sc3f09a9b6fa4fbed': `Inside`,
's2ba5f4d8f3bd7c57': `Order`,
'sdb73788b3c975f16': `Auto`,
'sae1c7f13b7c0c47f': `Start`,
'sb38d497d992ab4a4': `Center`,
'sd8f923198e0c5c6a': `End`,
's1749014f3f87fa6a': `Stretch`,
's602bbd28dae2c60f': `Self start`,
's6747dbf4ad6063ba': `Self end`,
'sebbced89e0db2894': `First baseline`,
's0ee28503778e4c0c': `Last baseline`,
's06743b24499f0035': `Anchor center`,
's1245e2cb9f20197e': `Align`,
'sa3b4c01623211544': `Force`,
'sef24caccbd4645ef': `Flex shrink`,
'sbfa01f189a68d3e9': `Flex grow`,
'saced41ddda8b2354': `Flex basis`,
's44cdba92713de38e': `Grid area`,
's05e9759cfd99c48f': `Justify`,
's0c4593d81f147042': `Baseline`,
'sc980855a000b76ea': `Bottom`,
's4101ada154a1b958': `Middle`,
's6d02dc19e21eb49c': `Top`,
's987abd19fac8cf55': `Sub`,
's9095f01a80a91594': `Super`,
'sf4b537d4cbd8f5fd': `Text top`,
's3fe72792941c18f9': `Text bottom`,
's27076e66c5d483ba': `Vertical align`,
'sd3c65ef5c380c046': `Inset`,
'sa5c371b4bb75e590': `Left`,
's366991b9c9287765': `Right`,
's9d167ef77aed79b6': `Layer`,
'sda344aacb837387e': `Position in container`,
'sf34696c526e810b4': `Inline`,
's2b2ae20d26f78ac2': `Block`,
'sda5b6fa8b771f996': `Float left`,
's2f0bcdffc92a786b': `Float right`,
's782f286a79cca35d': `Relative`,
'sa1c6c459b9b5115c': `Absolute`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sc1611c0558728a2a': `Position`,
'sf7a5f7a7c80c3082': `Both`,
's5be80ad6b8301710': `Inline start`,
'sf79e0d78b56444f1': `Inline end`,
'sb4f1dffbb6be6302': `Clear`,
'se5dc1e97fb743ade': `Spacing`,
's83f26d02dd7aa681': `Visible`,
's886897f2fd4edb99': `Hidden`,
's3e092e9d1ee2c5bb': `Clip`,
's94eb1effbbb6498b': `Overflow`,
's37a8c35f6581da5f': `No anchor`,
's2edd6688a65e21f0': `Overflow (x)`,
's2eda5288a65bca1d': `Overflow (y)`,
's3f1e7a3f2b283d3b': `Margin`,
's9370dc6afa716b57': `Border`,
's7d8103f6f06f83d6': `Padding`,
's5dc77784260a7236': `auto`,
'sf21fb4f4b9e8911f': `Width`,
'sffdadf0a576fd802': `Height`,
's1177237a3e0e548c': `Minimum (x)`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's7c61118554a0ec36': `Maximum (x)`,
'se79c0a3ac70d8fb3': `Asp. ratio (x)`,
'se79fae3ac710dc36': `Asp. ratio (y)`,
's19daf2f26c19543d': `Outline`,
'sd9ff8e2612e63d50': `Border box sizing`,
'sc1fff4f356dfb2fb': `Transform`,
's0b1271f50a77dc73': `Content box`,
's002fa7d1054ed082': `Border box`,
's74cd20a7aece9b91': `Fill box`,
's42721130228841b0': `Stroke box`,
'scbc55f622ec078c1': `View box`,
'sc462bbdd36bcba6b': `Reference box`,
'sc8ac7ef92b95df3f': `Move (x)`,
'sc8b022f92b992bc2': `Move (y)`,
'sc8b39af92b9c2d81': `Move (z)`,
'sf4f3cbd41f002b46': `Scale (x)`,
'sf4f067d41efd4b83': `Scale (y)`,
'sf4fa67d41f05a008': `Scale (z)`,
'sc6578b15b2154365': `Rotate (x)`,
'sc65aff15b2183e58': `Rotate (y)`,
'sc650ff15b20fe9d3': `Rotate (z)`,
'sf5197db2d5f2926a': `Rotate`,
's430bd5017f42511c': `Skew (x)`,
's430831017f3f0499': `Skew (y)`,
's36b3cefdcb897f15': `Perspective`,
'sc52e8b794c0913d6': `Perspective origin (x)`,
'sc52b67794c06a0d3': `Perspective origin (y)`,
'saa065776236bfa28': `Transform origin (x)`,
'saa02e3762368ff35': `Transform origin (y)`,
'sa9ff3b762365abe6': `Transform origin (z)`,
's166bd56d19670a72': `Zoom`,
's680bd4d926cd5a84': `Preserve 3D`,
's6a31eff1ec4f71ad': `Hide backface (3D)`,
's2de969afacdaa7a6': `Shape`,
'sd837f42ac7cbfb58': `Shape (outside)`,
's86f820d8007d0de4': `Shape margin`,
's6cfc66b824ea05ba': `Crisp edges`,
's7031ca562378bde6': `Geometric precision`,
'sd121d3b959b7888d': `Optimize speed`,
'sf2de3dbe2108637a': `Shape rendering`,
's5787c6d5b3b5541a': `Clip path`,
's372fae706048ce41': `Even-odd`,
's49c560aecfeb8c29': `Mask`,
's4fda04cbc245e18b': `Alpha`,
's1dbb9f50e16c92a3': `Border radius`,
's78673a3539cb1915': `Top left`,
's8b7580c35e2aef87': `Top left (y)`,
'sb0a7e3adf4a125ee': `Top right`,
's84e4e8ae645b82ac': `Top right (y)`,
'scfcb70f2a15eaf14': `Bottom right`,
'sdbee7e0523a23a42': `Bottom right (y)`,
'sef23dd271edd4a8b': `Bottom left`,
'sd5fd9d11a92f5b1d': `Bottom left (y)`,
'sdc12d4d35420eeb7': `Comments`,
's29acfd2778e8c377': `Hide advanced text formatting`,
's1a1acc902e6668e0': `Show advanced text formatting`,
's61eacb19db252f5e': `URL`,
's4fd2e638aabb0bb3': `WebWriter supports embedding many different sources. Simply paste a link to content from:`,
'sa79167651dce1e80': `Alternate text`,
'sa8bbe0197d31b423': `Short description`,
'seccd05955adb76bc': `Poster`,
's42e470ef1d707a28': `Autoplay`,
's83cd32b685ccc9b7': `Controls`,
's4efee5b48a4593cb': `Loop`,
'se0f67eae944f8f94': `Mute`,
's74540c1b595a229c': `TeX Formula`,
's65ac276544ba33cd': `SVG file`,
'sf22a3737146ec910': `WebWriter can embed SVG directly in the document.`,
'se036b53f145441cd': `Mixed Content`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'sb7c77d0415de05cf': `Run tests`,
's4dcb9315f6527f9c': `Run on reload`,
'sb430f5b4824de0d3': `Choose a layout`,
'seaf97719986faf4f': `Gap`,
'sab55faae8e165407': `Padding&lt;br&gt; like gap`,
'se58f06c2b0583ff7': `Pick coordinates`,
'sdf9bc5d9b7f3e3de': `Alignment`,
's626daf42b1ab7df7': `Align left`,
's13c60cb409e8cb6f': `Align center`,
'sac687b8649989de8': `Align right`,
's8d8643013a7754d1': `Align text`,
'se06f459fccdc3ce9': `Align last text line`,
'sfaa0a67db5c11f72': `Indent first text line`,
's95de7e1eff6c053e': `Horizontal, top-to-bottom`,
'sd8a345e95668b73b': `Vertical, right-to-left`,
's8ffe7abcbed8eb43': `Vertical, left-to-right`,
's986facb3ecc9602c': `Sideways, right-to-left`,
's063fa5a0a4903bf4': `Sideways, left-to-right`,
'sf190149f9d8bbb2a': `Writing mode`,
'se96fd76ba1b2975a': `Central`,
'sd8ecf227c7c49331': `Mathematical`,
'se8a94b4effa2033e': `Alphabetic`,
'scec2be75ee985f6c': `Ideographic`,
's7ecb1f29332293e5': `Alignment baseline`,
'sbf519920c2017d67': `Hanging`,
's40f07d7859284a44': `Dominant baseline`,
'sbb86c6c96f598bb8': `Mixed`,
's7b560d8693ed8f42': `Upright`,
's5b517ac216f9ee62': `Sideways`,
's47ebf3a8fb3b10c1': `Orientation`,
'sa1647e3b36ec08d7': `Combine upright`,
's0ef01c03299bbb83': `Decoration`,
'sc2a24a9dd41a9503': `Decoration line`,
'sb6ca0a8bb3caae69': `Decoration thickness`,
'sa43800e28be1bdbc': `Decoration color`,
's89950d86c8004d4b': `Skip no overlaps`,
's5e6a7a0c30d2a270': `Skip overlaps (auto)`,
'sb628960829e223bb': `Skip all overlaps`,
's3d9548e211b958ce': `Skip overlaps`,
's61ded17ca3f48c82': `Underline offset`,
's697400b541fbc3cd': `Under`,
's9219acd5bef6269e': `Under left`,
'sa13f72278add7513': `Under right`,
's9ab10fbf4c7a7322': `Underline position`,
's446a924922651ea0': `Text emphasis`,
'sd1f81984eeb7c0e8': `Fill`,
's266935f2447fcd98': `Over Left`,
's684a16f3c711394d': `Over Right`,
'sb940ade1bd81be7e': `Under Left`,
's60ff598dfcf2c773': `Under Right`,
's91093e0b087911ba': `Emphasis position`,
'sec02109a0dd2a6c8': `Emphasis color`,
's497838412cb455f2': `Text shadow`,
'sed86bd0deb2e5372': `Transform text`,
's4b2c143acf931122': `Line height`,
'sfb231a52211b133f': `No text wrap`,
'sb8a3d4df7d1c5e6b': `Balance`,
's27cc88818cc46ff6': `Stable`,
's3e78ddc9a48a608d': `Pretty`,
's31c06e226322f065': `Avoid orphans`,
'scd9cedeb5ece3adb': `Hyphenate`,
'se36c5b1baf5e0660': `Anywhere`,
's80b71fc6f43c5ce1': `Loose`,
's9ff3121d30f88d52': `Normal`,
's58bec0ecd4f3ccd4': `Strict`,
's2bad2d24def4aa0b': `Line break (CJK lang.)`,
's433ba70286202ceb': `Break all`,
'sd1cffad290ea5b3b': `Keep all`,
's5feaf7fd7ee567c8': `Break word`,
's4e361bf8eef3759a': `Word break`,
's4993444bfd3f3e5e': `Collapse`,
'sa8279f8211b3950d': `Preserve breaks and spaces`,
'sa757645ad842da97': `Preserve breaks`,
's9f1ecdb3061d9cbc': `Preserve spaces`,
's8d797888455f4147': `Break spaces`,
's95d8e41a64635c7c': `White space`,
's833bd0422a7ef95d': `Tab size`,
's050954cd4ae83304': `Word spacing`,
'sb2cda80610c8d6ea': `Space all`,
's4d546f6c87128d5b': `Space first`,
'sab0c57df694a0a09': `Trim start`,
's4730c232e7209c40': `Trim both`,
'sd3eca1e0f4209f6e': `Trim all`,
's0a2d91c6720033e9': `Text spacing trim`,
's74aa0039a87141e2': `Ellipsis`,
'sd588d17a1b25c220': `Text overflow`,
's079cf7850d9327f0': `Font`,
's61053f0e3ebbd272': `normal`,
'sd7086c4425c53c80': `Font family`,
'sa30f1981fd1cd441': `Font size`,
'sd8ce9e57270b030d': `Font stretch`,
's789ff24c8f03f1a4': `Letter spacing`,
's59404f5593c32fdc': `Font kerning`,
's236ed7ba747099b0': `Font weight`,
's517acbf1f96324f9': `Weight`,
'sd679c8b1bf8cc8a5': `Small caps`,
's7e6570f2f1ae320f': `Synthesize typefaces`,
'se7fad370d8fb4cec': `Optimize legibility`,
's6e288a119281f4c2': `Text rendering`,
'sc5bcf50d1b578d9f': `Font feature settings`,
's9eefe6e57e4e1661': `Font variant`,
'sc8fa0e3de389ef1c': `Font size adjust`,
's90f0fbc12e1e2b2f': `Font palette`,
'sc6da0f4a7e4d710e': `Font language override`,
'sc275dd00036d16cb': `Quotes character`,
'sd03bff50f87f82d4': `Hyphenate character`,
's16f205466761e583': `No optical font sizing`,
's344ea8f4939cdc98': `Color`,
's1efbfc3937d565bd': `Background`,
's3b0ab4b52326316f': `Light`,
'sac895c732f350ac5': `Dark`,
's255c77900f2b5e0f': `Color scheme`,
'sf1045382c1fd9a85': `Exact print colors`,
's1219d97b49650c05': `Visibility`,
'se2796c5824ec8916': `Content visibility`,
'sba64d8954d027206': `Opacity`,
'sf9929e2d356260c5': `Multiply`,
's744d993d03f29851': `Screen`,
's7ed13ccddb1bf3c3': `Overlay`,
's69fbbdb8ad2a084a': `Darken`,
's27056379e0acfdb0': `Lighten`,
's90f7c1cf501ea0a7': `Color dodge`,
'sfee1c12daf838935': `Color burn`,
's4ad6e9d3c2365c98': `Hard light`,
's262abbaf1d05f009': `Soft light`,
'sb67e0e7c0869f982': `Difference`,
'sd88076d2994ee0fb': `Exclusion`,
's491d2919cd6ec3d9': `Hue`,
's086e6c267ade2609': `Saturation`,
'sb8f610a0e8df91fc': `Luminosity`,
'sb905da066c10182c': `Plus darker`,
'sf14f9d5f9f6ca342': `Plus lighter`,
's6d8b3b8047ed378d': `Mix blend mode`,
'sdd2fc8919a9c3111': `Background blend mode`,
'sbb55f9f2d69fd327': `Backdrop filter`,
'sd2ed26defc646d47': `Backdrop Filter`,
's7c95876637f6a9d7': `Filter`,
's687e27f036a71b32': `Isolate`,
'sa602e3fd3f2d98fd': `Animation`,
'sf2d96d0eb32cb81f': `Animation composition`,
's9fc686f7bbd941e2': `Transition`,
'sf0e261e04eda82ff': `Appearance`,
'sd66c4767fa3dde28': `Accent color`,
's80a42b81c52d4d8f': `Caret color`,
's3815184eb09f0dcf': `Cursor`,
's1c690963f1e2df00': `Platform-specific look`,
'sb5e9e1776242b028': `Interactions`,
'sf2cbb5e519264e67': `Resize both horizontally and vertically`,
's7d864465dddbb50d': `Allow resizing`,
'sf6b4934598f7ed10': `Allow selection`,
's87cefc710b3567fb': `Contain`,
'sf993bb199fefbe04': `All`,
's571a4f19e2f140c7': `Pan (x)`,
's828b1ecea8715884': `Pan (left)`,
's40e3826b7f74a3b5': `Pan (right)`,
's571db319e2f4208a': `Pan (y)`,
's957787fc6b7ea5c0': `Pan (up)`,
'sc2b734cca2fa643b': `Pan (down)`,
's03608a32f05eded2': `Pinch zoom`,
's748c0074eff45884': `Manipulation`,
's7de0e28d6c309a4e': `Allow touch actions`,
'sc2536e077514accc': `Scrolling`,
's1155ec07a221e739': `Scrollbar`,
's5015a8fb33b98872': `Thin`,
'se95d4e55ea186d9a': `Scrollbar color`,
's6280bf993915c57a': `Scroll margin`,
's0c27336067c59611': `Scroll padding`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's001dd78415a91fa0': `Scrollbar gutter`,
'sf9ecf969dd4b8164': `Both edges`,
'saf9e5134ba1a7d30': `Scroll snap`,
'sea24bdcaa2bd2dec': `Mandatory snap`,
's6787497df07fa97e': `May scroll over stops`,
's9258280591309342': `Scroll snap align (x)`,
's92548405912d46bf': `Scroll snap align (y)`,
's624e31cd4f1b89d4': `Smooth scroll`,
'sb0f3327210fe18fc': `Columns`,
'sd01178c54f648118': `Balance columns`,
'sba88d90cd6c751b3': `Column rule`,
'sd3a288c1094b8a63': `Column rule width`,
's3124653c272f054c': `Column rule color`,
's01b56d233c6c5cac': `Sectioning`,
's68e0e3a2bab7ce3e': `Avoid`,
's314a4f7685c8e824': `Always`,
's4bbff4e008690da1': `Avoid page`,
's2e192b19ed15fcf6': `Page`,
'sae76e25497dcee58': `Recto`,
'sff3df0c2823ec6e4': `Verso`,
'seb19675a580f0628': `Avoid column`,
's9e40e59654c8ad67': `Column`,
's565cd5ffb0158c46': `Avoid region`,
'sb51270e19988f9bd': `Region`,
's8a29cb39a42f83f3': `Break before`,
'se638417c560cfe5c': `Break inside`,
's158b6ec6b1fffcb2': `Break after`,
'sfd0cde85070d2eb2': `Flex`,
'sa013e119fec906fb': `Row`,
's9d430adc5be110e9': `Row Reverse`,
'saaec15c97a9e4245': `Column Reverse`,
's0d86afa3c6a1e28b': `Flex direction`,
's1af8b67d1c85c811': `Space between`,
's456a8d744313852a': `Space around`,
's66765c420ee578e4': `Space evenly`,
's97881699a2b21d5b': `Row gap`,
's1aa1cb63ad44bc6f': `Column gap`,
'se619a501d1bfe6a5': `Wrap`,
's3ffcdc5db5e7d0c5': `Reverse`,
's25e1a07e454c2c11': `Grid`,
's6bd7a02fdf93e653': `Align content`,
's35ae5f4e0fa2777b': `Custom align`,
's6e4c20c6debcd5ca': `Custom justify`,
'se633223a0b88625e': `Cell placement`,
's88676f992b2965db': `Stretch cell content`,
's71dec51005acc1e4': `Row dense`,
's96a045dcade75ad0': `Column dense`,
'sb740eab4afd5a710': `Grid auto flow`,
'sa2eff4dad1c119f1': `Grid template`,
's13ebd619c8a06a6d': `Grid auto rows`,
'scbe537fc38ff4c13': `Grid auto columns`,
'sed713f1b916fb469': `Border spacing (x)`,
'sed74a31b9172942c': `Border spacing (y)`,
'sc1edebeaef92b7bd': `Fixed table layout`,
'sb59d621e3c93cc27': `Shared cell borders`,
'sa4f137f8619093a5': `Caption at bottom`,
's8a6585c48ea104e9': `Hide empty cells`,
's49dd67aed00029ef': `Math`,
'sad6be321164d08c8': `Compact math`,
's6ac62e1c8c66f3bb': `Compact superscr.`,
's036d35e03be98d22': `Math depth`,
's72f2a02e2a5a4ee3': `Media`,
's69d88ef4b2618980': `Cover`,
's29a1c26521879b9f': `Scale down`,
's0a3ddcba94027d95': `Object fit`,
's579c69f419b6caef': `Smooth`,
's741fae02b3dd24f3': `Pixelated`,
'sa126cf8c627cec1e': `Image rendering`,
'se58467472725ad0c': `Image resolution`,
'sab4d9283896d9422': `Snap resolution pixels`,
's0befccf152b6c0a9': `Orient from metadata`,
'sea52df2b70a5c10d': `Ruby`,
'sa644d580d8a11e60': `Ruby alignment`,
'sed318ec045c5144f': `Over`,
'sc53de149fcaad713': `Inter-character`,
's7d27db3c9639c6dd': `Alternate`,
'saad4380b9cc6cefd': `Alternate over`,
's037b1dc850a89273': `Alternate under`,
's3a179f6db2972384': `Ruby position`,
'sfcebd18506f1e535': `Flow`,
'sf0ca10f343249063': `Contents`,
's1125d159f7e64df5': `Display`,
'sca7cfe2bef51b2a5': `Root`,
'sca7fed2bef53cb99': `Role`,
'sf4849bc200e279ed': `Table caption`,
's41f65a763f8e44ab': `Table header group`,
's85f9aa6d3ea0e421': `Table footer group`,
'sc1a155cc25899250': `Table row group`,
's5b474b5c0ac0c7c4': `Table column group`,
's68b87d7b61052dc3': `Table row`,
's9caf10388ab3562f': `Table column`,
's07970793b21351fd': `Ruby base container`,
's8fad58c831ecf017': `Ruby text container`,
'sb0f93c1c60c0249a': `Ruby base`,
'sbd35ee879d9cf770': `Ruby text`,
'sea896ed51ad33287': `No specific styles available`,
's2b8f50c64be440f7': str`Select ${0}...`,
's739544d0c858c633': str`Or drop ${0} here`,
's851a7deea5984646': `License as Creative Commons OER?`,
's2540844a4bc4d9ba': `Require attribution?`,
'sb0a974028c99ca6d': `Allow adaptations?`,
's77e594ddcc10c774': `Allow commercial use?`,
'sa645d315510dc09e': `Choose path from disk`,
'seabae79729c4b2ad': `Toggle email`,
's34dcda3b0f9d5a98': `Toggle url`,
'sc3cfee84dbbf36ae': `Local File`,
's9896529e5cb20558': `External File`,
's7e0b179d4d1414eb': `Enter link`,
'sbe4a7c8f231739b3': `or paste/drop/pick file`,
's8a4ff2bd9c13498c': `Record`,
's1a5230a71d9285c1': `Capture`,
'sb71941f552f3504d': `Set special value`,
'sfb68cae41d749423': `Initial`,
's6b585ba37cdb8260': `Inherit`,
'sb45f9fb4dba6e71a': `Unset`,
'sd89a2e529b31ef43': `Revert`,
'sb741b6e0ca589122': `Revert layer`,
's844a76d1843ceb3c': `Reset to default`,
'sbba865d4b437944f': `Attribute`,
's16b9446e3a70e1f4': `Attributes`,
'sf471ec2496f904cc': `Discard changes`,
's418f2020fe996832': `Confirm changes`,
's3914cb410fca44d4': `Import`,
'sb66beca1e766dcb3': `Apply and import`,
'sed17285cd25d6389': `Directory where package.json is located`,
's2f8da2cb5f236588': `The name of your package. Must be scoped, e.g. \`@org/pkg\`. `,
's342b0cabfa672822': `Help the user find your widget`,
'sfdeef3dccf409f81': `This keyword is required for widgets`,
'h64cd12550420f6f1': html`Generate a <code>LICENSE</code> file`,
's255857544a9d5ec0': `Reset`,
's2591806d7b222591': `Reset changes`,
's445b8acb9206db6e': `Discard and cancel`,
's731678e227a20559': `This Device`,
's71940c32987f675f': `WebWriter Cloud`,
's323dcde72b850272': `Public access`,
's7ae49e142487766c': `Community access`,
'sfa49a5bb1a5d353e': `Private access`,
'sd0864ea6cb6ef22e': `Community`,
'sdd1ff479d04ac140': `Public`,
's99a990f3841ad283': `Files of `,
's3eb6d1e6e79ed7c4': `No documents found`,
's4e2562fe3990e621': `Error connecting`,
'sf52d840949a980d1': str`${0} will be deleted permanently. Are you sure?`,
's9b7cd8860c8fc922': str`${0} will be overwritten. Are you sure?`,
'see2fcaedf9743ec6': `Location`,
'sfdb1e4d90981a535': `Share this document`,
's1c3fc313a9184670': `Public Link`,
'sc28864200d2a3799': `Copy QR Code as image`,
'sfc815c9078bba30a': `Download QR Code as image`,
's4cb38675a21b2c98': `Unsupported property type '\${desc.type}' (processing as JSON)`,
'sa00df4e39c72d3b4': str`${0} is not supported`,
'sf65df67a03bebe4b': `Required for this widget`,
's8a9eb438abac7c6a': `Labels`,
'sba509fd8ed61d1d5': `Unsaved File`,
'sef00c258bc1ecf1e': `This explorable has unsaved changes.`,
'sb8f855b49234b81b': `Apply`,
'sc74e3567875ce255': `Both the tag of your widget and the name of your NPM package`,
's0dc452999c129e15': `Enable live reload`,
    };
  